import deviceTypes from '../../consts/device/deviceTypes';
import IAP_CUSTOM_FEATURE_NAMES from '../../consts/iap/iapCustomFeatureNames';
import IAP_DEVICE_FEATURE_CODES from '../../consts/iap/iapDeviceFeatureCodes';
import {getConfig} from '../../services/config/configService';

const getCustomFeatures = (featureName) => getConfig()?.customFeatures?.[featureName];

const getDeviceCertificates = () => {
    const certificatesString = getCustomFeatures(IAP_CUSTOM_FEATURE_NAMES.CA_CERTIFICATES);

    if (!certificatesString) return [];

    const certificatesArray = certificatesString.split(',').map((cert) => cert.trim());

    return certificatesArray;
};

const getDefaultDeviceType = () => {
    const defaultDeviceType = getCustomFeatures(IAP_CUSTOM_FEATURE_NAMES.DEFAULT_DEVICE_TYPE);

    switch (defaultDeviceType) {
        case IAP_DEVICE_FEATURE_CODES.ILUMA_I2:
            return deviceTypes.ILUMA_I2_CHARGER;
        case IAP_DEVICE_FEATURE_CODES.ILUMA_I5:
            return deviceTypes.ILUMA_I5_CHARGER;
        default:
            return deviceTypes.ILUMA_I5_CHARGER;
    }
};

const configCustomFeaturesGetters = {
    getCustomFeatures,
    getDeviceCertificates,
    getDefaultDeviceType,
};

export default configCustomFeaturesGetters;
